import { lazy, Suspense } from 'react'
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom'
import Layout from '@/components/layout/Layout'

import { ROUTES } from '@/utils/constants'

const Lab3DHome = lazy(() => import('@/pages/Lab3DHome'))
const About = lazy(() => import('@/pages/About'))
const Mission = lazy(() => import('@/pages/Mission'))
const GetHelp = lazy(() => import('@/pages/GetHelp'))
const Donate = lazy(() => import('@/pages/Donate'))
const Volunteer = lazy(() => import('@/pages/Volunteer'))
const VolunteerLogin = lazy(() => import('@/pages/VolunteerLogin'))
const VolunteerDashboard = lazy(() => import('@/pages/VolunteerDashboard'))
const Blog = lazy(() => import('@/pages/Blog'))
const BlogPost = lazy(() => import('@/pages/BlogPost'))
const Contact = lazy(() => import('@/pages/Contact'))
const Privacy = lazy(() => import('@/pages/Privacy'))
const Terms = lazy(() => import('@/pages/Terms'))
const AdminIntake = lazy(() => import('@/pages/AdminIntake'))
const AdminOrganizations = lazy(() => import('@/pages/AdminOrganizations'))
const AdminClients = lazy(() => import('@/pages/AdminClients'))
const AdminDistribution = lazy(() => import('@/pages/AdminDistribution'))
const AdminSettings = lazy(() => import('@/pages/AdminSettings'))
const AdminLaunch = lazy(() => import('@/pages/AdminLaunch'))
const AdminToday = lazy(() => import('@/pages/AdminToday'))
const AdminSchedule = lazy(() => import('@/pages/AdminSchedule'))
const AdminTasks = lazy(() => import('@/pages/AdminTasks'))
const AdminReports = lazy(() => import('@/pages/AdminReports'))
const AdminInbox = lazy(() => import('@/pages/AdminInbox'))
const StaffLogin = lazy(() => import('@/pages/StaffLogin'))
const ForgotPassword = lazy(() => import('@/pages/ForgotPassword'))
const ResetPassword = lazy(() => import('@/pages/ResetPassword'))
const PickupPass = lazy(() => import('@/pages/PickupPass'))

function RouteFallback() {
  return (
    <div role="status" className="flex min-h-screen items-center justify-center bg-white px-6 text-sm font-medium text-gray-700">
      Loading PC Food Pantry…
    </div>
  )
}

function App() {
  return (
    <BrowserRouter>
      <Suspense fallback={<RouteFallback />}>
        <Routes>
          <Route path={ROUTES.HOME} element={<Lab3DHome />} />
          <Route path={ROUTES.LAB_3D_HOME} element={<Lab3DHome />} />
          <Route element={<Layout />}>
            <Route path={ROUTES.ABOUT} element={<About />} />
            <Route path={ROUTES.MISSION} element={<Mission />} />
            <Route path={ROUTES.GET_HELP} element={<GetHelp />} />
            <Route path={ROUTES.DONATE} element={<Donate />} />
            <Route path={ROUTES.VOLUNTEER} element={<Volunteer />} />
            <Route path={ROUTES.BLOG} element={<Blog />} />
            <Route path={ROUTES.BLOG_POST} element={<BlogPost />} />
            <Route path={ROUTES.CONTACT} element={<Contact />} />
            <Route path={ROUTES.PRIVACY} element={<Privacy />} />
            <Route path={ROUTES.TERMS} element={<Terms />} />
          </Route>
          <Route path={ROUTES.ADMIN_LAUNCH} element={<AdminLaunch />} />
          <Route path={ROUTES.LOGIN} element={<StaffLogin />} />
          <Route path={ROUTES.VOLUNTEER_LOGIN} element={<VolunteerLogin />} />
          <Route path={ROUTES.VOLUNTEER_DASHBOARD} element={<VolunteerDashboard />} />
          <Route path={ROUTES.FORGOT_PASSWORD} element={<ForgotPassword />} />
          <Route path={ROUTES.RESET_PASSWORD} element={<ResetPassword />} />
          <Route path={ROUTES.VOLUNTEER_RESET_PASSWORD} element={<ResetPassword />} />
          <Route path="/pickup/:token" element={<PickupPass />} />
          <Route path={ROUTES.ADMIN_TODAY} element={<AdminToday />} />
          <Route path={ROUTES.ADMIN_INTAKE} element={<AdminIntake />} />
          <Route path={ROUTES.ADMIN_ORGANIZATIONS} element={<AdminOrganizations />} />
          <Route path={ROUTES.ADMIN_CLIENT_NEW} element={<AdminClients />} />
          <Route path={ROUTES.ADMIN_CLIENT_EDIT} element={<AdminClients />} />
          <Route path={ROUTES.ADMIN_CLIENTS} element={<AdminClients />} />
          <Route path={ROUTES.ADMIN_DISTRIBUTION} element={<AdminDistribution />} />
          <Route path={ROUTES.ADMIN_SCHEDULE} element={<AdminSchedule />} />
          <Route path={ROUTES.ADMIN_TASKS} element={<AdminTasks />} />
          <Route path={ROUTES.ADMIN_REPORTS} element={<AdminReports />} />
          <Route path={ROUTES.ADMIN_INBOX} element={<AdminInbox />} />
          <Route path={ROUTES.ADMIN_SETTINGS} element={<AdminSettings />} />
          <Route path="*" element={<Navigate to={ROUTES.HOME} replace />} />
        </Routes>
      </Suspense>
    </BrowserRouter>
  )
}

export default App

